import { render, staticRenderFns } from "./UITabBar.vue?vue&type=template&id=19b708ad&scoped=true&"
import script from "./UITabBar.vue?vue&type=script&lang=js&"
export * from "./UITabBar.vue?vue&type=script&lang=js&"
import style0 from "./UITabBar.vue?vue&type=style&index=0&id=19b708ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b708ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b708ad')) {
      api.createRecord('19b708ad', component.options)
    } else {
      api.reload('19b708ad', component.options)
    }
    module.hot.accept("./UITabBar.vue?vue&type=template&id=19b708ad&scoped=true&", function () {
      api.rerender('19b708ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UITabBar.vue"
export default component.exports